// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/deals-banner-small-logos-item/deals-banner-small-logos-item.component.scss
// module id = 251
// module chunks = 0